<template>
    <div class="icon-with-count-badge" :class="{ 'showing-count': props.count || props.showCountWhenZero }" :aria-label="props.ariaLabel">
        <font-awesome-icon :icon="props.icon" />
        <count-badge
            class="icon-with-count-badge__badge"
            :count="props.count"
            :aria-label="props.ariaLabel"
            :show-count-when-zero="props.showCountWhenZero"
        />
    </div>
</template>

<script setup lang="ts">
import CountBadge from '@/components/common/CountBadge.vue';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const props = withDefaults(defineProps<{
    icon: IconProp;
    count?: number;
    ariaLabel?: string;
    showCountWhenZero?: boolean;
}>(), {
    count: 0,
    ariaLabel: 'Count',
    showCountWhenZero: false,
});
</script>

<style scoped lang="scss">
.icon-with-count-badge {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.6rem;
    min-height: 2rem;
    color: var(--primaryFont);
    font-size: var(--defaultFontSize);
    overflow: visible;
}

.icon-with-count-badge__badge {
    position: absolute;
    top: -5px;
    right: -8px;
}

.showing-count {
    margin-right: 1rem;
}

</style>
